import { motion } from "framer-motion";
import { ChevronRight, Package, Layers, Printer, PenTool, Scissors, Truck } from "lucide-react";
import { AnimatedSection, fadeUp } from "@/components/motion";

const processSteps = [
  { label: "Fabric Sourcing", icon: Package },
  { label: "Dyeing & Processing", icon: Layers },
  { label: "Digital Printing", icon: Printer },
  { label: "Embroidery", icon: PenTool },
  { label: "Stitching", icon: Scissors },
  { label: "Finishing & Dispatch", icon: Truck },
];

export const VerticalIntegrationSection = () => (
  <AnimatedSection id="integration" className="py-24 lg:py-32 bg-background">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div variants={fadeUp} className="mb-16 max-w-2xl">
        <p className="text-xs font-sans uppercase tracking-[0.2em] text-[#C5A059] mb-4">End-to-End</p>
        <h2 className="text-4xl md:text-5xl font-serif tracking-tight text-foreground mb-6">
          A Fully Integrated Textile Ecosystem
        </h2>
        <p className="text-base font-sans text-muted-foreground leading-relaxed">
          From raw fabric to finished garments, our vertically integrated operations ensure complete control over quality, timelines, and customization.
        </p>
      </motion.div>
      <div className="horizontal-scroll pb-4">
        <div className="flex gap-6 min-w-max" data-testid="integration-flow">
          {processSteps.map((step, i) => (
            <motion.div
              key={step.label}
              variants={fadeUp}
              className="relative flex flex-col items-center w-48 flex-shrink-0"
            >
              <div className="w-16 h-16 rounded-full bg-[#0F172A] flex items-center justify-center mb-4">
                <step.icon size={24} className="text-[#C5A059]" strokeWidth={1.5} />
              </div>
              <p className="text-sm font-sans font-medium text-foreground text-center">{step.label}</p>
              {i < processSteps.length - 1 && (
                <div className="absolute top-8 left-[calc(50%+2rem)] w-[calc(100%-2rem)]">
                  <div className="h-px bg-[#C5A059]/40 w-full" />
                  <ChevronRight size={14} className="text-[#C5A059] absolute -right-1 -top-[7px]" />
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
      <motion.p variants={fadeUp} className="mt-12 text-sm font-sans text-muted-foreground tracking-wide">
        Efficiency meets craftsmanship at every stage.
      </motion.p>
    </div>
  </AnimatedSection>
);
